export default __webpack_public_path__ + "static/proximanova-semibold-woff-ffd2177afcaa20d69e0a6186605e06e0.woff";